import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["container", "id", "name", "disabled", "visible", "placeholder", "src", "alt", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createElementBlock("img", {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ImageTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ImageTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.ImageTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.ImageTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ImageTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ImageTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ImageTypeConst.PLACEHOLDER),
        src: _ctx.getPropertyValue(_ctx.ImageTypeConst.SRC),
        alt: _ctx.getPropertyValue(_ctx.ImageTypeConst.ALT),
        width: _ctx.getPropertyValue(_ctx.ImageTypeConst.WIDTH),
        height: _ctx.getPropertyValue(_ctx.ImageTypeConst.HEIGHT),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clicktest && _ctx.clicktest(...args)))
      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ImageTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}